import React from "react";
import { Dialog, DialogProps } from "primereact/dialog";
import AppDialogFooter, { AppDialogFooterProps } from "./AppDialogFooter";
import "./AppDialog.scss";

export type AppDialogProps = DialogProps & {
    /** Standard footer: cancel (left, text) + submit (right, primary). */
    footerActions?: AppDialogFooterProps;
};

const AppDialog: React.FC<AppDialogProps> = ({
    className,
    modal = true,
    blockScroll = true,
    draggable = false,
    resizable = false,
    footer,
    footerActions,
    ...props
}) => {
    const dialogClassName = className
        ? `app-dialog ${className}`
        : "app-dialog";

    const resolvedFooter = footerActions
        ? <AppDialogFooter {...footerActions} />
        : footer;

    return (
        <Dialog
            {...props}
            modal={modal}
            draggable={draggable}
            resizable={resizable}
            blockScroll={blockScroll ?? modal}
            footer={resolvedFooter}
            className={dialogClassName}
            data-dashly-overlay-host=""
        />
    );
};

export default AppDialog;
export { AppDialogFooter };
export type { AppDialogFooterProps } from "./AppDialogFooter";
